import { Button } from "@dune/ui";
import React from "react";
import { useMe } from "../../../api/queries/users.queries";
import { RoleEnum } from "../../../../../../packages/vars/src";

interface ReservesBlockProps {
	reserves: string[];
	isActive: boolean;
	onLiftReserves: () => void;
}

export const ReservesBlock: React.FC<ReservesBlockProps> = ({
	reserves,
	isActive,
	onLiftReserves,
}) => {
	const { me } = useMe();
	if (!isActive || reserves.length === 0) {
		return null;
	}

	const canLiftReserves = me?.role !== RoleEnum.BROKER;

	return (
		<div className="bg-orange-50 border border-orange-200 rounded-lg p-6">
			<div className="flex items-start justify-between mb-4">
				<h3 className="text-orange-800 font-medium text-base leading-tight">
					La proposition est établie sous réserve de la transmission des
					éléments suivants :
				</h3>
				{canLiftReserves && (
					<Button
						onClick={onLiftReserves}
						className="bg-orange-600 hover:bg-orange-700 text-white ml-4 flex-shrink-0"
					>
						Lever les réserves
					</Button>
				)}
			</div>
			<div className="space-y-3">
				{reserves.map((reserve) => (
					<div key={reserve} className="flex items-start">
						<span className="text-orange-600 mr-3 mt-0.5 text-lg leading-none">
							•
						</span>
						<span className="text-orange-800 text-sm leading-relaxed flex-1">
							{reserve}
						</span>
					</div>
				))}
			</div>
		</div>
	);
};
